export const CREATE_EDOK_FORM_SUCCESS = 'CREATE_EDOK_FORM_SUCCESS';

export const createEdokFormSuccess = ({ form }) => ({
    type: CREATE_EDOK_FORM_SUCCESS,
    payload: {
        form,
    }
});
